"use client";

import { useEffect, useState } from "react";
import { Icon } from "./icons";

type ClientRecord = {
  name: string;
  contact: string;
  industry: string;
  status: string;
  value: string;
  initials: string;
  id?: string;
};

export function ClientsView() {
  const [selected, setSelected] = useState<ClientRecord | null>(null);
  const [records, setRecords] = useState<ClientRecord[]>([]);
  const [creating, setCreating] = useState(false);
  const [form, setForm] = useState({ companyName: "", contactName: "", email: "" });
  const [error, setError] = useState("");
  useEffect(() => {
    fetch("/api/clients")
      .then((response) => (response.ok ? response.json() : { clients: [] }))
      .then((data) =>
        setRecords(
          data.clients.map(
            (client: {
              company_name: string;
              contact_name: string;
              status: string;
              id: string;
            }) => ({
              name: client.company_name,
              contact: client.contact_name ?? "—",
              industry: "—",
              status: client.status,
              value: "—",
              initials: client.company_name.slice(0, 2),
              id: client.id,
            }),
          ),
        ),
      );
  }, []);
  return (
    <section className="module-view" data-amazi-id={"crm/src/features/crm/clients-view.tsx:47:5"}>
      <div className="module-heading" data-amazi-id={"crm/src/features/crm/clients-view.tsx:48:7"}>
        <div data-amazi-id={"crm/src/features/crm/clients-view.tsx:49:9"}>
          <div className="breadcrumb" data-amazi-id={"crm/src/features/crm/clients-view.tsx:50:11"}>
            Рабочее пространство <span data-amazi-id={"crm/src/features/crm/clients-view.tsx:51:34"}>/</span> Клиенты
          </div>
          <h1 data-amazi-id={"crm/src/features/crm/clients-view.tsx:53:11"}>Клиенты</h1>
          <p data-amazi-id={"crm/src/features/crm/clients-view.tsx:54:11"}>{records.length} клиентов загружено из базы ателье</p>
        </div>
        <button className="primary-button" onClick={() => setCreating(true)} data-amazi-id={"crm/src/features/crm/clients-view.tsx:56:9"}>
          <Icon name="plus" size={16} data-amazi-jsx-id={"crm/src/features/crm/clients-view.tsx:57:11"} /> Новый клиент
        </button>
      </div>
      {creating && (
        <form
          className="panel create-form"
          onSubmit={(event) => {
            event.preventDefault();
            setError("");
            fetch("/api/clients", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(form),
            })
              .then(async (response) => {
                if (!response.ok) throw new Error((await response.json()).error);
                setCreating(false);
              })
              .catch((reason: Error) => setError(reason.message));
          }}
         data-amazi-id={"crm/src/features/crm/clients-view.tsx:61:9"}>
          <h2 data-amazi-id={"crm/src/features/crm/clients-view.tsx:78:11"}>Новый клиент</h2>
          {error && (
            <div className="form-error" role="alert" data-amazi-id={"crm/src/features/crm/clients-view.tsx:80:13"}>
              {error}
            </div>
          )}
          <input
            required
            placeholder="Название компании"
            value={form.companyName}
            onChange={(event) => setForm({ ...form, companyName: event.target.value })} data-amazi-id={"crm/src/features/crm/clients-view.tsx:84:11"}
          />
          <input
            placeholder="Контактное лицо"
            value={form.contactName}
            onChange={(event) => setForm({ ...form, contactName: event.target.value })} data-amazi-id={"crm/src/features/crm/clients-view.tsx:90:11"}
          />
          <input
            type="email"
            placeholder="Email"
            value={form.email}
            onChange={(event) => setForm({ ...form, email: event.target.value })} data-amazi-id={"crm/src/features/crm/clients-view.tsx:95:11"}
          />
          <div data-amazi-id={"crm/src/features/crm/clients-view.tsx:101:11"}>
            <button type="button" className="select-button" onClick={() => setCreating(false)} data-amazi-id={"crm/src/features/crm/clients-view.tsx:102:13"}>
              Отмена
            </button>{" "}
            <button className="primary-button" data-amazi-id={"crm/src/features/crm/clients-view.tsx:105:13"}>Создать клиента</button>
          </div>
        </form>
      )}
      <div className="toolbar" data-amazi-id={"crm/src/features/crm/clients-view.tsx:109:7"}>
        <button className="search" data-amazi-id={"crm/src/features/crm/clients-view.tsx:110:9"}>
          <Icon name="search" size={17} data-amazi-jsx-id={"crm/src/features/crm/clients-view.tsx:111:11"} />
          <span data-amazi-id={"crm/src/features/crm/clients-view.tsx:112:11"}>Поиск по клиентам</span>
        </button>
        <button className="select-button" data-amazi-id={"crm/src/features/crm/clients-view.tsx:114:9"}>
          Все статусы <span data-amazi-id={"crm/src/features/crm/clients-view.tsx:115:23"}>⌄</span>
        </button>
      </div>
      <div className="client-layout" data-amazi-id={"crm/src/features/crm/clients-view.tsx:118:7"}>
        <div className="panel client-table" data-amazi-id={"crm/src/features/crm/clients-view.tsx:119:9"}>
          <div className="table-head" data-amazi-id={"crm/src/features/crm/clients-view.tsx:120:11"}>
            <span data-amazi-id={"crm/src/features/crm/clients-view.tsx:121:13"}>Клиент</span>
            <span data-amazi-id={"crm/src/features/crm/clients-view.tsx:122:13"}>Контактное лицо</span>
            <span data-amazi-id={"crm/src/features/crm/clients-view.tsx:123:13"}>Изделия</span>
            <span data-amazi-id={"crm/src/features/crm/clients-view.tsx:124:13"}>Статус</span>
            <span data-amazi-id={"crm/src/features/crm/clients-view.tsx:125:13"}>Сумма заказов</span>
          </div>
          {records.length === 0 && (
            <div className="empty-message" data-amazi-id={"crm/src/features/crm/clients-view.tsx:128:13"}>
              Клиентов пока нет. Добавьте первого клиента, чтобы начать работу.
            </div>
          )}
          {records.map((client) => (
            <button className="client-row" key={client.name} onClick={() => setSelected(client)} data-amazi-id={"crm/src/features/crm/clients-view.tsx:133:13"}>
              <span className="client-name" data-amazi-id={"crm/src/features/crm/clients-view.tsx:134:15"}>
                <i data-amazi-id={"crm/src/features/crm/clients-view.tsx:135:17"}>{client.initials}</i>
                <strong data-amazi-id={"crm/src/features/crm/clients-view.tsx:136:17"}>{client.name}</strong>
              </span>
              <span data-amazi-id={"crm/src/features/crm/clients-view.tsx:138:15"}>{client.contact}</span>
              <span data-amazi-id={"crm/src/features/crm/clients-view.tsx:139:15"}>{client.industry}</span>
              <span data-amazi-id={"crm/src/features/crm/clients-view.tsx:140:15"}>
                <em
                  className={`status ${client.status === "Активный" ? "status-green" : client.status === "Новый" ? "status-blue" : "status-orange"}`}
                 data-amazi-id={"crm/src/features/crm/clients-view.tsx:141:17"}>
                  {client.status}
                </em>
              </span>
              <b data-amazi-id={"crm/src/features/crm/clients-view.tsx:147:15"}>{client.value}</b>
            </button>
          ))}
        </div>
        {selected && (
          <div className="panel client-detail" data-amazi-id={"crm/src/features/crm/clients-view.tsx:152:11"}>
            <button className="close-detail" onClick={() => setSelected(null)} data-amazi-id={"crm/src/features/crm/clients-view.tsx:153:13"}>
              ×
            </button>
            <div className="detail-avatar" data-amazi-id={"crm/src/features/crm/clients-view.tsx:156:13"}>{selected.initials}</div>
            <h2 data-amazi-id={"crm/src/features/crm/clients-view.tsx:157:13"}>{selected.name}</h2>
            <p data-amazi-id={"crm/src/features/crm/clients-view.tsx:158:13"}>{selected.industry}</p>
            <div className="detail-status" data-amazi-id={"crm/src/features/crm/clients-view.tsx:159:13"}>
              <em className="status status-green" data-amazi-id={"crm/src/features/crm/clients-view.tsx:160:15"}>{selected.status}</em>
            </div>
            <dl data-amazi-id={"crm/src/features/crm/clients-view.tsx:162:13"}>
              <div data-amazi-id={"crm/src/features/crm/clients-view.tsx:163:15"}>
                <dt data-amazi-id={"crm/src/features/crm/clients-view.tsx:164:17"}>Контактное лицо</dt>
                <dd data-amazi-id={"crm/src/features/crm/clients-view.tsx:165:17"}>{selected.contact}</dd>
              </div>
              <div data-amazi-id={"crm/src/features/crm/clients-view.tsx:167:15"}>
                <dt data-amazi-id={"crm/src/features/crm/clients-view.tsx:168:17"}>Заказы</dt>
                <dd data-amazi-id={"crm/src/features/crm/clients-view.tsx:169:17"}>{selected.value}</dd>
              </div>
              <div data-amazi-id={"crm/src/features/crm/clients-view.tsx:171:15"}>
                <dt data-amazi-id={"crm/src/features/crm/clients-view.tsx:172:17"}>Ответственный</dt>
                <dd data-amazi-id={"crm/src/features/crm/clients-view.tsx:173:17"}>Анна Крылова</dd>
              </div>
            </dl>
            <button className="outline-button" data-amazi-id={"crm/src/features/crm/clients-view.tsx:176:13"}>
              <Icon name="plus" size={15} data-amazi-jsx-id={"crm/src/features/crm/clients-view.tsx:177:15"} /> Добавить заметку
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
